import { LabelProps, PanelProps } from "@mcleod/components";
import { AbstractSectionPanel } from "./AbstractSectionPanel";
import { AddlExampleLinePanel } from "./AddlExampleLinePanel";
import { ExpandButton } from "./ExpandButton";

export class AddlExampleLineHeaderPanel extends AddlExampleLinePanel {
    constructor(sectionPanel: AbstractSectionPanel, props?: Partial<PanelProps>) {
        super(null, null, null, props);
        this.addExpandAllButton(sectionPanel);
    }

    protected override getNameColumnDef(): Partial<LabelProps> {
        return { ...super.getNameColumnDef(), text: "Name", fontSize: "large" };
    }

    protected override getDescrColumnDef(): Partial<LabelProps> {
        return { ...super.getDescrColumnDef(), text: "Description", fontBold: true, fontSize: "large" };
    }

    private addExpandAllButton(sectionPanel: AbstractSectionPanel) {
        const expandAllButton = new ExpandButton(sectionPanel, true);
        this.add(expandAllButton);
    }
}
